import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const isUpperCase = (str) => str === str.toUpperCase();

const Typography = () => <span />;

Typography.Headline = ({ ariaLabel, className, forceUppercase, level: Tag, value: __html }) => (
  <Tag
    aria-label={ariaLabel || isUpperCase(__html) ? __html.toLowerCase() : undefined}
    className={cx(
      className,
      styles.typography,
      forceUppercase ? styles.forceUppercase : styles.initialCase
    )}
    dangerouslySetInnerHTML={{ __html }}
  />
);

Typography.Headline.propTypes = {
  className: PropTypes.string,
  forceUppercase: PropTypes.bool,
  level: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default Typography;
